var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Watch } from "vue-property-decorator";
import { GetSessionTimeout, ExtendUserSession } from '@/graphql/queries/users';
import { BIconX, BModal } from "bootstrap-vue";
import axios from "axios";
var TimeoutManager = /** @class */ (function (_super) {
    __extends(TimeoutManager, _super);
    function TimeoutManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeoutDuration = 300000; // 5 minutes in milliseconds
        _this.warningTime = 180000; // 30 seconds in milliseconds
        _this.countdown = 0; // Initialize countdown
        _this.countdownInterval = null; // Store interval ID to clear it later
        _this.timeoutId = null; // Store timeout ID to clear it later
        // Full circle length (2 * PI * r)
        _this.circleLength = 2 * Math.PI * 45; // 2πr
        // Initialize offset to full circle length
        _this.circleOffset = 0;
        return _this;
    }
    TimeoutManager.prototype.onUserStatusChanged = function (newVal) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(newVal === 'success')) return [3 /*break*/, 2];
                        if (!this.$store.getters['hasSession']) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initTimer()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TimeoutManager.prototype.initTimer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$apollo.query({
                                query: GetSessionTimeout,
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        this.timeoutDuration = data.sessionTimeout.duration;
                        // Clear any existing timeout
                        if (this.timeoutId) {
                            clearTimeout(this.timeoutId);
                        }
                        // Set a new timeout
                        this.timeoutId = setTimeout(function () {
                            _this.$refs.modal.show();
                            _this.startCountdown();
                        }, this.timeoutDuration - this.warningTime);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Error fetching session timeout duration:", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TimeoutManager.prototype.startCountdown = function () {
        var _this = this;
        this.countdown = Math.floor(this.warningTime / 1000);
        // Calculate the decrement amount per second
        var incrementAmount = this.circleLength / (this.warningTime / 1000);
        this.countdown = Math.floor(this.warningTime / 1000);
        this.circleOffset = 0;
        this.countdownInterval = setInterval(function () {
            _this.countdown--;
            _this.circleOffset += incrementAmount;
            if (_this.countdown <= 0) {
                clearInterval(_this.countdownInterval);
                axios.post('/logout').then(function (response) {
                    localStorage.removeItem('auth_token');
                    delete axios.defaults.headers.common['Authorization'];
                    window.location.href = '/fuerenand/session-timeout';
                }).catch(function (error) {
                    localStorage.removeItem('auth_token');
                    delete axios.defaults.headers.common['Authorization'];
                    window.location.href = '/fuerenand/session-timeout';
                });
            }
        }, 1000);
    };
    TimeoutManager.prototype.extendTimeout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        // Clear existing countdown
                        clearInterval(this.countdownInterval);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: ExtendUserSession,
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        if (!data.extendUserSession.success) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.initTimer()];
                    case 2:
                        _a.sent();
                        this.$refs.modal.hide();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        console.error("Error while extending the session: ", error_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Watch('$store.state.session.user.status', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], TimeoutManager.prototype, "onUserStatusChanged", null);
    TimeoutManager = __decorate([
        Component({
            components: { BModal: BModal, BIconX: BIconX }
        })
    ], TimeoutManager);
    return TimeoutManager;
}(Vue));
export default TimeoutManager;
